import React from 'react';
import { Row, Column } from '@upgrade/react-components';
import { Section } from '../common/styles';
import Fluid from '../Fluid';
import DataTable from './table';
import { TableContainer, StyledTextContainer, TitleContainers } from './styles';
import { StyledP, StyledCaption } from '../common/typography';
import { toHtmlSanitize } from '../../utils/remark-html';
import { Heading } from '../common/TypographyPublicSite';

const LowerCostSection = ({
  lowerCostSection: { title, subtitle, headline, subheadline, backgroundColor, table },
  borderless
}) => (
  <Section data-color={backgroundColor} {...{ borderless }}>
    <Fluid>
      <Row gutter="large" xsHorizontalAlign="center">
        <TitleContainers>
          <Column xs={12} sm={10}>
            <Heading as="h2" size="sm">
              {title}
            </Heading>
            {subtitle && <StyledP>{subtitle}</StyledP>}
            {headline && (
              <Heading as="h3" size="xxs">
                {headline}
              </Heading>
            )}
            {subheadline && <StyledP>{subheadline}</StyledP>}
          </Column>
        </TitleContainers>
      </Row>
      <Row smHorizontalAlign="center">
        <Column xs={12} sm={9}>
          <TableContainer>{table && <DataTable {...table} />}</TableContainer>
        </Column>
      </Row>
      <Row gutter="large" smHorizontalAlign="center">
        <Column xs={12} sm={8}>
          {table && (
            <StyledTextContainer>
              <StyledCaption dangerouslySetInnerHTML={{ __html: toHtmlSanitize(table.firstFootnote) }} />
              <StyledCaption dangerouslySetInnerHTML={{ __html: toHtmlSanitize(table.secondFootnote) }} />
              <StyledCaption dangerouslySetInnerHTML={{ __html: toHtmlSanitize(table.thirdFootnote) }} />
            </StyledTextContainer>
          )}
        </Column>
      </Row>
    </Fluid>
  </Section>
);

export default LowerCostSection;
